export default __webpack_public_path__ + "static/media/PL.e2978cd5.svg";